<app-nav-menu></app-nav-menu>
<div class="newlistsection">
  <div class="heading_section mt-2">
    <div class="row justify-content-center">
      Import PNR List
    </div>
 
  </div>
  <div class="row mt-2">
    <div class="col-md-3">
      <ng-select #agency [items]="agencyList" bindLabel="labelName" bindValue="code" [searchable]="true" [ngModelOptions]="{standalone: true}"
                 [(ngModel)]="selectedValue" placeholder="Search Agency_Branch" class="branchinfongselect"
                 (change)="AgencyCodeChange(selectedValue)">
      </ng-select>
    </div>
    
  </div>
  <div class="mt-3">
    <dx-data-grid [dataSource]="importpnrlist"
                  [showBorders]="true"
                  [showRowLines]="true"
                  [columnAutoWidth]="true">
      <dxo-paging [pageSize]="10"> </dxo-paging>
      <dxo-pager [visible]="true">
      </dxo-pager>
      <dxi-column dataField="bookingDate" alignment="center" caption="Booking Date"></dxi-column>
      <dxi-column [visible]="false" dataField="bookingID" alignment="center" caption="Booking ID"></dxi-column>
      <dxi-column dataField="agencyId" alignment="center" caption="Booking ID"></dxi-column>
      <dxi-column dataField="supplier" alignment="center" caption="Supplier"></dxi-column>
      <dxi-column dataField="pnr" alignment="center" caption="PNR"></dxi-column>
      <dxi-column dataField="tkt" alignment="center" caption="TKT"></dxi-column>
      <dxi-column dataField="trip" alignment="center" caption="Trip"></dxi-column>
      <dxi-column dataField="name" alignment="center" caption="Name"></dxi-column>
      <dxi-column dataField="travelDate" alignment="center" caption="Travel Date"></dxi-column>
      <dxi-column dataField="bookingStatus" alignment="center" caption="Status"></dxi-column>
      
      <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate"></dxi-column>
      <dxo-search-panel [visible]="true"></dxo-search-panel>

      <div *dxTemplate="let data of 'actionCellTemplate'">
        <a (click)="Edit_Click(data.data)"><i class="uil uil-edit action-class">Manage</i></a>
      </div>
    </dx-data-grid>
  </div>
</div>
